import { render } from "./EsqueciMinhaSenha.vue?vue&type=template&id=3ad62eab&scoped=true"
import script from "./EsqueciMinhaSenha.vue?vue&type=script&lang=js"
export * from "./EsqueciMinhaSenha.vue?vue&type=script&lang=js"

import "./EsqueciMinhaSenha.vue?vue&type=style&index=0&id=3ad62eab&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad62eab"]])

export default __exports__